import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { IPhotoGallery } from './photogallery.model';

@Component({
  selector: 'app-photogallery',
  templateUrl: './photogallery.component.html',
  styleUrls: ['./photogallery.component.css'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatCardModule],
})
export class PhotoGalleryComponent {
  @Input() images: IPhotoGallery[] = [];
  currentIndex: number = 0;
  imagesPerRow: number = 4;
  enlargedImage: IPhotoGallery;

  @ViewChild('imageDialog') imageDialog: TemplateRef<any> | undefined;
  constructor(private dialog: MatDialog) {}

  get visibleImages(): IPhotoGallery[] {
    const totalImages = this.images?.length || 0;
    if (totalImages == 0) return [];

    const visibleImages = [];
    for (let i = 0; i < this.imagesPerRow; i++) {
      const index = (this.currentIndex + i) % totalImages;
      visibleImages.push(this.images[index]);
    }
    return visibleImages;
  }

  next(): void {
    if (this.currentIndex < this.images.length - this.imagesPerRow) {
      this.currentIndex += this.imagesPerRow;
    } else {
      this.currentIndex = 0;
    }
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex -= this.imagesPerRow;
    } else {
      this.currentIndex = this.images.length - this.imagesPerRow;
    }
  }

  openImage(image: IPhotoGallery): void {
    this.enlargedImage = image;
    this.dialog.open(this.imageDialog as TemplateRef<any>, {
      panelClass: 'image-dialog',
      maxWidth: '95vw',
      maxHeight: '95vh',
      width: '95vw',
      height: '95vh',
    });
  }

  previousImage() {
    let index = this.images.indexOf(this.enlargedImage);
    if (index - 1 >= 0) {
      index--;
    } else {
      index = this.images.length - 1;
    }
    this.enlargedImage = this.images[index];
  }

  nextImage() {
    let index = this.images.indexOf(this.enlargedImage);
    if (index + 1 < this.images.length - 1) {
      index++;
    } else {
      index = 0;
    }
    this.enlargedImage = this.images[index];
  }
}
